import React from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import FnrIcon from "UI/FnrIcon";
import { colors } from "UI/colors";

export default function LearnMore({ ...props }) {
  return (
    <Wrapper {...props}>
      <Description>
        <DescriptionItem>
          <DescriptionItemIcon>
            <FnrIcon fas fa-lock-alt />
          </DescriptionItemIcon>
          <DescriptionItemText>
            Secure online & mobile payments.
          </DescriptionItemText>
        </DescriptionItem>

        <DescriptionItem>
          <DescriptionItemIcon>
            <FnrIcon fas fa-sync-alt />
          </DescriptionItemIcon>
          <DescriptionItemText>
            Hassle-free recurring donations.
          </DescriptionItemText>
        </DescriptionItem>

        <DescriptionItem>
          <DescriptionItemIcon>
            <FnrIcon fas fa-dollar-sign />
          </DescriptionItemIcon>
          <DescriptionItemText>
            No contracts, monthly fees, or setup fees.
          </DescriptionItemText>
        </DescriptionItem>
      </Description>

      <ButtonHolder>
        {/* <SafeEasy>Safe. Easy. 1 Minute Setup.</SafeEasy> */}
        <SafeEasy>Included with all Flocknote plans!</SafeEasy>
        <FnrButton
          onClick={() => window.fnReactBus.goToUrl("/fundit")}
          color={colors.fnYellow}
          size="large"
        >
          Learn More
        </FnrButton>
      </ButtonHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const Description = styled.div``;

const DescriptionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 6px;
  @media screen and (max-width: 400px) {
    gap: 10px;
  }
`;

const DescriptionItemIcon = styled.div`
  width: 70px;
  text-align: center;
  font-size: 24px;
  flex-grow: 0;
  flex-shrink: 0;
  @media screen and (max-width: 590px) {
    width: 60px;
  }
  @media screen and (max-width: 400px) {
    width: 30px;
    font-size: 22px;
  }
`;

const DescriptionItemText = styled.div`
  font-size: 20px;
  color: #184770;
  font-weight: 400;
  @media screen and (max-width: 590px) {
    font-size: 18px;
  }
`;

const ButtonHolder = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SafeEasy = styled.div`
  color: white;
  font-weight: 400;
  font-style: italic;
`;
